import React, { useState } from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";

const categories = [ "Web", "Software", "App", "Video", "Design", "Ads"];

const projects = [
  // ── Web ──
  {
    category: "Web",
    title: "Siyaram Irrigation",
    type: "Website",
    desc: "Professional business website for an irrigation company showcasing products, services and dealer network.",
    result: "More dealer inquiries",
    tags: ["React", "Node.js", "SEO"],
    image: "/portfolio/siyaram-irrigation.png",
    gradient: "from-cyan-400 to-blue-400",
    bgLight: "from-cyan-50 to-blue-50",
    borderColor: "border-cyan-200",
    tagColor: "bg-cyan-100 text-cyan-700 border-cyan-200",
    resultColor: "text-cyan-700 bg-cyan-50 border-cyan-200",
  },
  {
    category: "Web",
    title: "Dev Industries",
    type: "Website",
    desc: "Corporate website for an industrial manufacturing firm with about , mission , product catalogue and enquiry system.",
    result: "2x lead generation",
    tags: ["React", "Node.js", "Tailwind"],
    image: "/portfolio/dev-industries.png",
    gradient: "from-slate-400 to-blue-400",
    bgLight: "from-slate-50 to-blue-50",
    borderColor: "border-slate-200",
    tagColor: "bg-slate-100 text-slate-700 border-slate-200",
    resultColor: "text-slate-700 bg-slate-50 border-slate-200",
  },
  {
    category: "Web",
    title: "Dalmia Steel",
    type: "Website",
    desc: "Modern steel industry website with product listing, pricing enquiry and distributor management.",
    result: "Higher distributor reach",
    tags: ["React", "Tailwind", "CMS"],
    image: "/portfolio/dalmia-steel.png",
    gradient: "from-gray-400 to-zinc-500",
    bgLight: "from-gray-50 to-zinc-50",
    borderColor: "border-gray-200",
    tagColor: "bg-gray-100 text-gray-700 border-gray-200",
    resultColor: "text-gray-700 bg-gray-50 border-gray-200",
  },

  // ── Software ──
  {
    category: "Software",
    title: "Real Estate Software",
    type: "Web App",
    desc: "End-to-end real estate management platform with property listings, client CRM and deal tracking.",
    result: "50% faster deal closure",
    tags: ["React", "Node.js", "MongoDB"],
    image: "/portfolio/real-estate-software.png",
    gradient: "from-purple-400 to-pink-300",
    bgLight: "from-purple-50 to-pink-50",
    borderColor: "border-purple-200",
    tagColor: "bg-purple-100 text-purple-700 border-purple-200",
    resultColor: "text-purple-700 bg-purple-50 border-purple-200",
  },
  {
    category: "Software",
    title: "Business Management",
    type: "Web App",
    desc: "All-in-one business management suite — invoicing, inventory, HR and financial reporting in one place.",
    result: "Saves 15hrs/week",
    tags: ["React", "Next.js", "Mongodb"],
    image: "/portfolio/business-management.png",
    gradient: "from-indigo-400 to-blue-300",
    bgLight: "from-indigo-50 to-blue-50",
    borderColor: "border-indigo-200",
    tagColor: "bg-indigo-100 text-indigo-700 border-indigo-200",
    resultColor: "text-indigo-700 bg-indigo-50 border-indigo-200",
  },
  {
    category: "Software",
    title: "Irrigation Management",
    type: "Web App",
    desc: "Smart irrigation management system for tracking water usage, schedules and field monitoring in real-time.",
    result: "30% water saved",
    tags: ["React Native", "Node", "Firebase"],
    image: "/portfolio/irrigation-management.png",
    gradient: "from-green-400 to-teal-300",
    bgLight: "from-green-50 to-teal-50",
    borderColor: "border-green-200",
    tagColor: "bg-green-100 text-green-700 border-green-200",
    resultColor: "text-green-700 bg-green-50 border-green-200",
  },

  // ── App ──
  {
    category: "App",
    title: "Apna Crusher",
    type: "Mobile App",
    desc: "Mobile app for crusher businesses to manage orders, track production and handle billing on the go.",
    result: "Shipped in 5 weeks",
    tags: ["React Native", "Firebase", "Android"],
    image: "/portfolio/apna-crusher.png",
    gradient: "from-orange-400 to-yellow-300",
    bgLight: "from-orange-50 to-yellow-50",
    borderColor: "border-orange-200",
    tagColor: "bg-orange-100 text-orange-700 border-orange-200",
    resultColor: "text-orange-700 bg-orange-50 border-orange-200",
  },
  {
    category: "App",
    title: "Growth Guide Academy",
    type: "Ed-Tech App",
    desc: "E-learning app with live classes, recorded courses, quizzes and student progress tracking.",
    result: "1000+ active learners",
    tags: ["Android", "Node.js", "Razorpay"],
    image: "/portfolio/growth-guide.png",
    gradient: "from-blue-400 to-sky-300",
    bgLight: "from-blue-50 to-sky-50",
    borderColor: "border-blue-200",
    tagColor: "bg-blue-100 text-blue-700 border-blue-200",
    resultColor: "text-blue-700 bg-blue-50 border-blue-200",
  },
  {
    category: "App",
    title: "Logical IS",
    type: "Mobile App",
    desc: "Intelligent school management app for admissions, attendance, fees and parent communication.",
    result: "Adopted by 5 schools",
    tags: ["Flutter", "Firebase", "iOS/Android"],
    image: "/portfolio/logical-is.png",
    gradient: "from-violet-400 to-purple-300",
    bgLight: "from-violet-50 to-purple-50",
    borderColor: "border-violet-200",
    tagColor: "bg-violet-100 text-violet-700 border-violet-200",
    resultColor: "text-violet-700 bg-violet-50 border-violet-200",
  },

  // ── Video ──
  {
    category: "Video",
    title: "UGC Videos",
    type: "Video Production",
    desc: "User-generated style content videos for brands — authentic, scroll-stopping and conversion-focused.",
    result: "3x engagement rate",
    tags: ["UGC", "Scripting", "Direction"],
    image: "/portfolio/ugc-video.png",
    gradient: "from-pink-400 to-rose-300",
    bgLight: "from-pink-50 to-rose-50",
    borderColor: "border-pink-200",
    tagColor: "bg-pink-100 text-pink-700 border-pink-200",
    resultColor: "text-pink-700 bg-pink-50 border-pink-200",
  },
  {
    category: "Video",
    title: "Video Editing",
    type: "Post Production",
    desc: "Professional video editing for Reels, YouTube, ads and brand films with motion graphics and colour grading.",
    result: "500K+ views delivered",
    tags: ["Premiere Pro", "After Effects", "Color Grading"],
    image: "/portfolio/video-editing.png",
    gradient: "from-red-400 to-orange-300",
    bgLight: "from-red-50 to-orange-50",
    borderColor: "border-red-200",
    tagColor: "bg-red-100 text-red-700 border-red-200",
    resultColor: "text-red-700 bg-red-50 border-red-200",
  },
  {
    category: "Video",
    title: "AI Videos",
    type: "AI Production",
    desc: "AI-powered video generation for product explainers, brand stories and social content at scale.",
    result: "10x faster production",
    tags: ["AI Tools", "Scripting", "Voiceover"],
    image: "/portfolio/ai-video.png",
    gradient: "from-fuchsia-400 to-purple-400",
    bgLight: "from-fuchsia-50 to-purple-50",
    borderColor: "border-fuchsia-200",
    tagColor: "bg-fuchsia-100 text-fuchsia-700 border-fuchsia-200",
    resultColor: "text-fuchsia-700 bg-fuchsia-50 border-fuchsia-200",
  },

  // ── Design ──
  {
    category: "Design",
    title: "Poster Design",
    type: "Graphic Design",
    desc: "Eye-catching promotional posters for events, offers and brand campaigns — print & digital ready.",
    result: "Higher footfall & clicks",
    tags: ["Photoshop", "Illustrator", "Canva Pro"],
    image: "/portfolio/poster-design.png",
    gradient: "from-yellow-400 to-orange-300",
    bgLight: "from-yellow-50 to-orange-50",
    borderColor: "border-yellow-200",
    tagColor: "bg-yellow-100 text-yellow-700 border-yellow-200",
    resultColor: "text-yellow-700 bg-yellow-50 border-yellow-200",
  },
  {
    category: "Design",
    title: "Carousel & Post Design",
    type: "Social Media Design",
    desc: "Swipeable carousels, feed posts and story designs that boost saves, shares and profile visits.",
    result: "2x profile visits",
    tags: ["Figma", "Canva Pro", "Branding"],
    image: "/portfolio/carousel-design.png",
    gradient: "from-teal-400 to-cyan-300",
    bgLight: "from-teal-50 to-cyan-50",
    borderColor: "border-teal-200",
    tagColor: "bg-teal-100 text-teal-700 border-teal-200",
    resultColor: "text-teal-700 bg-teal-50 border-teal-200",
  },
  {
    category: "Design",
    title: "Story Design",
    type: "Social Media Design",
    desc: "Branded Instagram & WhatsApp story templates — animated and static — built for daily posting.",
    result: "Consistent brand look",
    tags: ["After Effects", "Figma", "Motion"],
    image: "/portfolio/story-design.png",
    gradient: "from-lime-400 to-green-300",
    bgLight: "from-lime-50 to-green-50",
    borderColor: "border-lime-200",
    tagColor: "bg-lime-100 text-lime-700 border-lime-200",
    resultColor: "text-lime-700 bg-lime-50 border-lime-200",
  },

  // ── Ads ──
  {
    category: "Ads",
    title: "Service-Based Ads",
    type: "Meta & Google Ads",
    desc: "Performance ad campaigns for service businesses — plumbers, clinics, coaches — driving quality leads.",
    result: "60% lower CPL",
    tags: ["Meta Ads", "Google Ads", "Copywriting"],
    image: "/portfolio/service-ads.png",
    gradient: "from-blue-500 to-indigo-400",
    bgLight: "from-blue-50 to-indigo-50",
    borderColor: "border-blue-200",
    tagColor: "bg-blue-100 text-blue-700 border-blue-200",
    resultColor: "text-blue-700 bg-blue-50 border-blue-200",
  },
  {
    category: "Ads",
    title: "Shopping Ads",
    type: "E-commerce Ads",
    desc: "Google Shopping & Meta catalogue ads for D2C brands — optimised for ROAS and cart value.",
    result: "4.8x ROAS achieved",
    tags: ["Google Shopping", "Meta Catalogue", "Pixel"],
    image: "/portfolio/shopping-ads.png",
    gradient: "from-orange-400 to-pink-400",
    bgLight: "from-orange-50 to-pink-50",
    borderColor: "border-orange-200",
    tagColor: "bg-orange-100 text-orange-700 border-orange-200",
    resultColor: "text-orange-700 bg-orange-50 border-orange-200",
  },
  {
    category: "Ads",
    title: "Lead Generation Ads",
    type: "Performance Marketing",
    desc: "End-to-end lead gen campaigns with landing pages, A/B testing and CRM integration for maximum ROI.",
    result: "300+ leads/month",
    tags: ["Meta Ads", "Landing Page", "CRM"],
    image: "/portfolio/lead-gen-ads.png",
    gradient: "from-emerald-400 to-teal-400",
    bgLight: "from-emerald-50 to-teal-50",
    borderColor: "border-emerald-200",
    tagColor: "bg-emerald-100 text-emerald-700 border-emerald-200",
    resultColor: "text-emerald-700 bg-emerald-50 border-emerald-200",
  },
];

export default function Portfolio() {
  const ref = useScrollAnimation();
  const [active, setActive] = useState("Web");

  const filtered = projects.filter((p) => p.category === active);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Fraunces:wght@700;900&display=swap');
        .port-heading { font-family: 'Fraunces', serif; }
        .port-body    { font-family: 'Plus Jakarta Sans', sans-serif; }
      `}</style>

      <section
        id="portfolio"
        className="py-24 relative overflow-hidden bg-gradient-to-b from-white to-blue-50"
      >
        <div className="absolute top-10 right-0 w-80 h-80 bg-sky-100/60 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-blue-100/50 rounded-full blur-3xl pointer-events-none" />

        <div className="max-w-7xl mx-auto px-5 md:px-10 relative">

          {/* Heading */}
          <div ref={ref} className="section-animate text-center mb-12">
            <span className="port-body inline-block text-xs font-bold text-blue-600 tracking-widest uppercase bg-blue-100 border border-blue-200 rounded-full px-5 py-1.5 mb-5">
              Our Work
            </span>
            <h2 className="port-heading font-black text-4xl md:text-6xl text-black mb-4 leading-tight">
              Selected{" "}
              <span
                style={{
                  background: "linear-gradient(135deg, #1d4ed8 0%, #0ea5e9 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                Portfolio
              </span>
            </h2>
            <p className="port-body text-slate-500 text-lg font-medium">
              Quality work, real results — no filler, no fluff.
            </p>
          </div>

          {/* Category filter */}
          <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-12">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                className={`port-body text-xs md:text-sm font-semibold px-4 md:px-5 py-2 rounded-full border transition-all duration-200 ${
                  active === c
                    ? "bg-blue-600 text-white border-blue-600 shadow-md shadow-blue-200"
                    : "border-blue-200 text-slate-500 bg-white hover:border-blue-400 hover:text-blue-600 hover:bg-blue-50"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          {/* Projects grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((p, i) => (
              <div
                key={i}
                className={`group bg-white border ${p.borderColor} rounded overflow-hidden shadow-sm hover:shadow-xl hover:shadow-blue-100/60 transition-all duration-300 hover:-translate-y-1`}
              >
                {/* Thumbnail */}
                <div className="relative h-48 overflow-hidden bg-gray-100">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      // Fallback to gradient if image missing
                      e.currentTarget.style.display = "none";
                      e.currentTarget.parentElement.classList.add(
                        `bg-gradient-to-br`, p.gradient
                      );
                    }}
                  />

                  {/* Dark overlay on hover */}
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300" />

                  {/* Type badge — top right */}
                  <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm border border-white/60 rounded-full px-3 py-1 shadow-sm">
                    <span className="port-body text-xs font-bold text-slate-700">
                      {p.type}
                    </span>
                  </div>

                  {/* Result badge — bottom left */}
                  <div
                    className={`absolute bottom-3 left-3 bg-white/90 backdrop-blur-sm border rounded-full px-3 py-1 shadow-sm ${p.resultColor}`}
                  >
                    <span className="port-body text-xs font-bold flex items-center gap-1">
                      <span>✦</span> {p.result}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className={`p-6 bg-gradient-to-b ${p.bgLight}`}>
                  <h3 className="port-heading font-bold text-xl text-black mb-2 leading-snug">
                    {p.title}
                  </h3>
                  <p className="port-body text-slate-500 text-sm leading-relaxed mb-5 font-medium">
                    {p.desc}
                  </p>

                  {/* Tags */}
                  <div className="flex flex-wrap gap-2 mb-5">
                    {p.tags.map((t, j) => (
                      <span
                        key={j}
                        className={`port-body text-xs font-semibold border rounded-full px-3 py-1 ${p.tagColor}`}
                      >
                        {t}
                      </span>
                    ))}
                  </div>

                  {/* View link */}
                  <a
                    href="#contact"
                    className="port-body inline-flex items-center gap-1.5 text-xs font-bold text-blue-600 hover:text-blue-800 transition-colors duration-200 group/link"
                  >
                    View Case Study
                    <span className="group-hover/link:translate-x-1 inline-block transition-transform duration-200">→</span>
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom CTA */}
          <div className="text-center mt-14">
            <p className="port-body text-slate-400 text-sm mb-4 font-medium">
              Want to see more of our work?
            </p>
            <a
              href="#contact"
              className="port-body inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-bold text-sm px-8 py-4 rounded-full transition-all duration-300 hover:scale-105 shadow-lg shadow-blue-200"
            >
              View Full Portfolio →
            </a>
          </div>
        </div>
      </section>
    </>
  );
}